import DailyReport from "./DailyReport.vue";
export default DailyReport;
